export default __webpack_public_path__ + "static/media/default.3baf468c094aa876ad2d95571f3390c3.png";